import UploadModal from '../components/UploadModal'
import { connect } from 'react-redux'
import {setShowUploadModal, setContents, setParsedContext, clearVocabularyType, setSelectedContext } from '../util/actions'

const mapStateToProps = (state) => ({
  showUploadModal: state.mapping.showUploadModal,
  isMapping: state.mapping.isMapping
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleClickOK: (e, props, object) => {
    e.preventDefault()
    if (props.isMapping) {
      dispatch(setContents(object))
    } else {
      dispatch(setParsedContext(object))
    }
    dispatch(clearVocabularyType({}))
    dispatch(setSelectedContext({}))
    dispatch(setShowUploadModal(false))
  },
  handleClickCancel: () => {
    dispatch(setShowUploadModal(false))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(UploadModal)


// WEBPACK FOOTER //
// ./src/containers/UploadModal.js